
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/contacts",
      function () {
        return require("private-next-pages/about/contacts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/contacts"])
      });
    }
  